import { ModuleFilter, ModuleTagging } from '../types';

import { buildModuleSlugSet } from './buildModuleSlugSet';

export function buildModuleEnabledPredicate({
  moduleTagging,
  enable,
  disable,
}: {
  moduleTagging: readonly ModuleTagging[];
  enable?: ModuleFilter;
  disable?: ModuleFilter;
}): (moduleSlug: string) => boolean {
  // Build enabled set from enabled parameter (all possible focus values)
  const modulesEnabled = enable
    ? buildModuleSlugSet(enable, moduleTagging)
    : undefined;

  // Build the set of modules to disable based on disable tags
  const modulesToDisable = disable
    ? buildModuleSlugSet(disable, moduleTagging)
    : new Set<string>();

  return (slug) =>
    (modulesEnabled ? modulesEnabled.has(slug) : true) &&
    !modulesToDisable.has(slug);
}
